import * as React from 'react';
import { Ref, Segment, Table as UITable } from 'semantic-ui-react';
export var CompanyPayments = function (_a) {
    var detail = _a.detail, children = _a.children;
    var ref1 = React.useRef(null);
    var ref2 = React.useRef(null);
    var _b = React.useState([0, 0, 0]), margin = _b[0], setMargin = _b[1];
    React.useEffect(function () {
        if (ref1.current !== null && ref2.current !== null) {
            setMargin([ref1.current.offsetWidth, ref2.current.offsetWidth + ref1.current.offsetWidth]);
        }
    }, []);
    return (<div data-testid={detail.type}>
			{children}
			<Segment.Group compact>
				<UITable celled collapsing padded striped structured unstackable className='sticky-column-3' size='small'>
					<UITable.Header>
						<UITable.Row>
							<Ref innerRef={ref1}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: 0 }}>
									Lečivý přípravek
								</UITable.HeaderCell>
							</Ref>
							<Ref innerRef={ref2}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: margin[0] }}>
									Doplněk
								</UITable.HeaderCell>
							</Ref>
							<UITable.HeaderCell data-testid='record-header' style={{ left: margin[1] }}>
								SUKL kód
							</UITable.HeaderCell>
							{detail.paidPackages[0].records.map(function (record, i) { return (<UITable.HeaderCell data-testid='record-header' key={i} textAlign='right'>
									{record.insuranceCompany}
								</UITable.HeaderCell>); })}
							<UITable.HeaderCell data-testid='record-header' textAlign='right'>
								Total
							</UITable.HeaderCell>
						</UITable.Row>
					</UITable.Header>
					<UITable.Body>
						{detail.paidPackages.map(function (pack, i) { return (<UITable.Row data-testid='record' key={i}>
								<UITable.Cell singleLine style={{ left: 0 }}>
									{pack.brand}
								</UITable.Cell>
								<UITable.Cell singleLine style={{ left: margin[0] }}>
									{pack.supplement}
								</UITable.Cell>
								<UITable.Cell singleLine style={{ left: margin[1] }}>
									{pack.suklCode}
								</UITable.Cell>
								{pack.records.map(function (record, j) {
                var _a;
                return (<UITable.Cell singleLine key={j} textAlign='right'>
										{"".concat((_a = record.amountOfPackages) !== null && _a !== void 0 ? _a : '-', " ").concat(record.estimated ? '*' : '')}
									</UITable.Cell>);
            })}
								<UITable.Cell singleLine data-testid='total' textAlign='right'>
									{pack.totalNumberOfPaidPackages}
								</UITable.Cell>
							</UITable.Row>); })}
					</UITable.Body>
				</UITable>
			</Segment.Group>
			<p>
				Symbol * označuje odhadnutý počet balení, neboť od daných pojišťoven zatím nebyla data obdržena. Odhadnutý počet
				se může změnit.
			</p>
		</div>);
};
